import React, { useState } from 'react'
import homeofficewithbookshelf1 from '../../assets/designgallery/Home Office/L_shapedHomeOfficeWithBookshelf/homeofficewithbookshelf (1).jpg'
import homeofficewithbookshelf2 from '../../assets/designgallery/Home Office/L_shapedHomeOfficeWithBookshelf/homeofficewithbookshelf (2).jpg'
import homeofficewithbookshelf3 from '../../assets/designgallery/Home Office/L_shapedHomeOfficeWithBookshelf/homeofficewithbookshelf (3).jpg'
import homeofficewithbookshelf4 from '../../assets/designgallery/Home Office/L_shapedHomeOfficeWithBookshelf/homeofficewithbookshelf (4).jpg'
import homeofficewithbookshelf5 from '../../assets/designgallery/Home Office/L_shapedHomeOfficeWithBookshelf/homeofficewithbookshelf (5).jpg'
import homeofficewithbookshelf6 from '../../assets/designgallery/Home Office/L_shapedHomeOfficeWithBookshelf/homeofficewithbookshelf (6).jpg'


import homeofficeatbedroomcorner1 from '../../assets/designgallery/Home Office/HomeOfficeBedroom/homeofficeatbedroomcorner (1).jpg'
import homeofficeatbedroomcorner2 from '../../assets/designgallery/Home Office/HomeOfficeBedroom/homeofficeatbedroomcorner (2).jpg'
import homeofficeatbedroomcorner3 from '../../assets/designgallery/Home Office/HomeOfficeBedroom/homeofficeatbedroomcorner (3).jpg'
import homeofficeatbedroomcorner4 from '../../assets/designgallery/Home Office/HomeOfficeBedroom/homeofficeatbedroomcorner (4).jpg'
import homeofficeatbedroomcorner5 from '../../assets/designgallery/Home Office/HomeOfficeBedroom/homeofficeatbedroomcorner (5).jpg'
import homeofficeatbedroomcorner6 from '../../assets/designgallery/Home Office/HomeOfficeBedroom/homeofficeatbedroomcorner (6).jpg'


import homeofficelivingroom1 from '../../assets/designgallery/Home Office/HomeOfficeLivingRoom/homeofficelivingroom (4).jpg'
import homeofficelivingroom2 from '../../assets/designgallery/Home Office/HomeOfficeLivingRoom/homeofficelivingroom (2).jpg'
import homeofficelivingroom3 from '../../assets/designgallery/Home Office/HomeOfficeLivingRoom/homeofficelivingroom (6).jpg'
import homeofficelivingroom4 from '../../assets/designgallery/Home Office/HomeOfficeLivingRoom/homeofficelivingroom (7).jpg'
import homeofficelivingroom5 from '../../assets/designgallery/Home Office/HomeOfficeLivingRoom/homeofficelivingroom (8).jpg'
import homeofficelivingroom6 from '../../assets/designgallery/Home Office/HomeOfficeLivingRoom/homeofficelivingroom (9).jpg'


import twoin1tvcumofficeunit1 from '../../assets/designgallery/Home Office/2in1TVCumOfficUnit/2in1tvcumofficeunit (1).avif'
import twoin1tvcumofficeunit2 from '../../assets/designgallery/Home Office/2in1TVCumOfficUnit/2in1tvcumofficeunit (2).avif'
import twoin1tvcumofficeunit3 from '../../assets/designgallery/Home Office/2in1TVCumOfficUnit/2in1tvcumofficeunit (3).avif'
import twoin1tvcumofficeunit4 from '../../assets/designgallery/Home Office/2in1TVCumOfficUnit/2in1tvcumofficeunit (1).jpg'
import twoin1tvcumofficeunit5 from '../../assets/designgallery/Home Office/2in1TVCumOfficUnit/2in1tvcumofficeunit (5).jpg'
import twoin1tvcumofficeunit6 from '../../assets/designgallery/Home Office/2in1TVCumOfficUnit/2in1tvcumofficeunit (9).jpg'

import industrialstylehomeoffice1 from '../../assets/designgallery/Home Office/IndustrialStyleHomeOffice/industrialstylehomeoffice (1).jpg'
import industrialstylehomeoffice2 from '../../assets/designgallery/Home Office/IndustrialStyleHomeOffice/industrialstylehomeoffice (2).jpg'
import industrialstylehomeoffice3 from '../../assets/designgallery/Home Office/IndustrialStyleHomeOffice/industrialstylehomeoffice (3).jpg'
import industrialstylehomeoffice4 from '../../assets/designgallery/Home Office/IndustrialStyleHomeOffice/industrialstylehomeoffice (4).jpg'
import industrialstylehomeoffice5 from '../../assets/designgallery/Home Office/IndustrialStyleHomeOffice/industrialstylehomeoffice (5).jpg'
import industrialstylehomeoffice6 from '../../assets/designgallery/Home Office/IndustrialStyleHomeOffice/industrialstylehomeoffice (6).jpg'

import { Link } from 'react-router-dom'
import { BiSolidOffer } from 'react-icons/bi'
import { MdOutlineReplay10, MdOutlineThumbUpAlt } from 'react-icons/md'

const HomeOffice = () => {
    // *****************************************
    const [isExpanded1, setIsExpanded1] = useState(true);
    const toggleContent1 = () => {
    setIsExpanded1(prev => !prev);
    };
    // *****************************************
    // *****************************************
    const [isExpanded2, setIsExpanded2] = useState(false);
    const toggleContent2 = () => {
    setIsExpanded2(prev => !prev);
    };
    // *****************************************
  return (
    <div className='home-office  design-gallery'>
        <div className='home-office-heading container'>
            <h3>Home Office Designs</h3>
            <p>
                Check out popular Home Office Room Designs amongst our happy customers.
            </p>
        </div>
        {/* ********************************************** */}

        <div className=' shapes container'>
            {/* slider-1 */}
            <div id="carouselExampleIndicators" class="carousel slide">
                                                <div class="carousel-indicators">
                                                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                                </div>
                                              <div class="carousel-inner">
                                                  <div class="carousel-item active">
                                                    <img src={homeofficewithbookshelf1} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficewithbookshelf2} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficewithbookshelf3} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficewithbookshelf4} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficewithbookshelf5} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficewithbookshelf6} class="d-block w-100" alt="..."/>
                                                </div>
                                              </div>
                                              <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Previous</span>
                                              </button>
                                              <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Next</span>
                                              </button>
            </div>

            <div className='images-details mt-3'>
                            <p className='img-details-and-btn'>An L-shaped Home Office With An Attached Bookshelf<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                             {/* Show more button */}
                             {!isExpanded1 && (
                                <button 
                                  className='show-more btn mt-2'
                                  onClick={toggleContent1}
                                  aria-expanded={isExpanded1}
                                >
                                 Show More ▼  
                                </button>
                             )}

                             {/* Expanded content */}
                             {isExpanded1 &&(
                                <div className='extra-info mt-3'>
                                    <p className='extra-info-para'>
                                    This home office has been set up by the window to craft a creative workspace at home.
                                    The space with the L-shaped desk and open and closed shelves is bright and cheerful and provides ample storage options as well.
                                    </p>
                                    <p className='extra-info-features'>Special Features</p>
                                    <ul className='extra-info-list'>
                                        <li>The unique design of this home office creates a lot of desk space.</li>
                                        <li>The L-shaped wooden desk has handleless drawers in high gloss laminate.</li>
                                        <li>The workstation has open drawers to keep frequently used items.</li>
                                        <li>The strip lighting and the table lamp keep the area brightly lit even at night.</li>
                                        <li>The workstation is attached to a tall wooden bookshelf which in turn adjoins a white high gloss laminate wardrobe.</li>
                                        <li>The home office comes with a wood-finish armless bucket chair.</li>
                                    </ul>

                                 {/* Show less button */}
                                 <button
                                  className='show-less btn  mt-3'
                                  onClick={toggleContent1}
                                  aria-expanded={isExpanded1}
                                  >
                                   Show Less ▲  
                                  </button>
                                </div>
                             )}
                            
            </div>
            {/* slider-1  end*/}
            <div style={{margin:'80px'}}  ></div>
           

            {/* slidedr-2 */}
            <div id="carouselExampleIndicators2" class="carousel slide">
                                                <div class="carousel-indicators">
                                                  <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                                </div>
                                              <div class="carousel-inner">
                                                  <div class="carousel-item active">
                                                    <img src={homeofficeatbedroomcorner1} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficeatbedroomcorner2} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficeatbedroomcorner3} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficeatbedroomcorner4} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficeatbedroomcorner5} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficeatbedroomcorner6} class="d-block w-100" alt="..."/>
                                                </div>
                                              </div>
                                              <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="prev">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Previous</span>
                                              </button>
                                              <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="next">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Next</span>
                                              </button>
            </div>

            <div className='images-details mt-3'>
                            <p className='img-details-and-btn'>A Minimalist Home Office Tucked Into A Corner Of Your Bedroom<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                             {/* Show more button */}
                             {!isExpanded2 && (
                                <button 
                                  className='show-more btn mt-2'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                >
                                 Show More ▼  
                                </button>
                             )}

                             {/* Expanded content */}
                             {isExpanded2 &&(
                                <div className='extra-info mt-3'>
                                    <p className='extra-info-para'>
                                    This home office, designed as a part of a master bedroom, is minimalistic in appeal with clean lines and sleek furniture.
                                    The office is enclosed within wooden-frame glass doors and is perfect for anyone looking for a distraction-free workspace.
                                    </p>
                                    <p className='extra-info-features'>Special Features</p>
                                    <ul className='extra-info-list'>
                                      <li>A sleek, white laminated work desk with handleless drawers enables an uncluttered look.</li>
                                      <li>The desk has a floating shelf and a cabinet with handleless drawers.</li>
                                      <li>The workstation also has a chest of wooden drawers that brings in an organic appeal.</li>
                                      <li>The home office comes with a plastic barrel chair for comfortable seating.</li>
                                      <li>The minimalist style home office is decorated with framed posters, a simple wall clock, a pinboard and a fluffy rug.</li>
                                      <li>The office corner is enclosed within a wooden glass frame.</li>

                                    </ul>

                                 {/* Show less button */}
                                 <button
                                  className='show-less btn  mt-3'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                  >
                                   Show Less ▲  
                                  </button>
                                </div>
                             )}
                            
            </div>


            {/* slider-2 end */}
            <div style={{margin:'80px'}}  ></div>


            {/* slider-3 */}
            <div id="carouselExampleIndicators3" class="carousel slide">
                                                <div class="carousel-indicators">
                                                  <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                                </div>
                                              <div class="carousel-inner">
                                                  <div class="carousel-item active">
                                                    <img src={homeofficelivingroom1} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficelivingroom2} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficelivingroom3} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficelivingroom4} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficelivingroom5} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={homeofficelivingroom6} class="d-block w-100" alt="..."/>
                                                </div>
                                              </div>
                                              <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Previous</span>
                                              </button>
                                              <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="next">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Next</span>
                                              </button>
            </div>


             <div className='images-details mt-3'>
                            <p className='img-details-and-btn'>A Space-Saving Home Office Setup For Living Room<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                             {/* Show more button */}
                             {!isExpanded2 && (
                                <button 
                                  className='show-more btn mt-2'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                >
                                 Show More ▼  
                                </button>
                             )}

                             {/* Expanded content */}
                             {isExpanded2 &&(
                                <div className='extra-info mt-3'>
                                    <p className='extra-info-para'>
                                  This home office setup has an ideal space-saving design. The work desk is a part of the TV unit and forms a complete home office/entertainment unit.
                                  The work desk comes with a wall-mounted desk and floating shelves–perfectly adequate for agile professionals. This small but multifunctional work unit can work great for modern Indian apartments.
                                    </p>

                                    <p className='extra-info-features'>Special Features</p>
                                    <ul className='extra-info-list'>
                                      <li>A wall-mounted work desk unit with floating shelves to store books and work documents.</li>
                                      <li>The work desk remains attached to an open shelf unit, providing additional storage for office essentials.</li>
                                      <li>The open shelf unit evolves to form a two-seater bench.</li>
                                      <li>The work desk is attached to an open bookshelf unit that evolves to form a comfortable two-seater bench.</li>
                                      <li>An armless wooden bucket chair completes the home office unit.</li>
                                    </ul>

                                 {/* Show less button */}
                                 <button
                                  className='show-less btn  mt-3'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                  >
                                   Show Less ▲  
                                  </button>
                                </div>
                             )}
                            
            </div>

            {/* slider-3 end */}
            <div style={{margin:'80px'}}  ></div>

        </div>
        {/* *********************************************************** */}
        {/*whychooseourkitchen*/}
                      <div className='whyourkitchen'>
                        <h3>Why Choose Our Home Office Designs</h3>
                         <div className='whyourkitchen-reason'>
                          <div className='icon-para-div1'>
                            <BiSolidOffer className='icon'/>
                            <p className='whyourkitchen-para'>20% Extra Space</p>
                          </div>
                          <div className='icon-para-div1'>
                            <MdOutlineReplay10  className='icon'/>
                            <p className='whyourkitchen-para'>10 Year Warranty</p>
                          </div>
                          <div className='icon-para-div1'>
                            <MdOutlineThumbUpAlt  className='icon'/>
                            <p className='whyourkitchen-para'>Installation by Professionals</p>
                          </div>
                         </div>
                      </div>
        {/*whychooseourkitchen*/}
        <div className='shapes container'>
            {/* slider-4 */}
             <div id="carouselExampleIndicators4" class="carousel slide">
                                                <div class="carousel-indicators">
                                                  <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                                </div>
                                              <div class="carousel-inner">
                                                  <div class="carousel-item active">
                                                    <img src={twoin1tvcumofficeunit1} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={twoin1tvcumofficeunit2} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={twoin1tvcumofficeunit3} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={twoin1tvcumofficeunit4} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={twoin1tvcumofficeunit5} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={twoin1tvcumofficeunit6} class="d-block w-100" alt="..."/>
                                                </div>
                                              </div>
                                              <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="prev">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Previous</span>
                                              </button>
                                              <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="next">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Next</span>
                                              </button>
             </div>

            <div className='images-details mt-3'>
                            <p className='img-details-and-btn'>A 2 In 1 TV Cum Home Office Unit For Living Room<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                             {/* Show more button */}
                             {!isExpanded2 && (
                                <button 
                                  className='show-more btn mt-2'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                >
                                 Show More ▼  
                                </button>
                             )}

                             {/* Expanded content */}
                             {isExpanded2 &&(
                                <div className='extra-info mt-3'>
                                    <p className='extra-info-para'>
                                    This home office is an ensemble of a work desk unit, a TV unit and a bookshelf. This design makes the work setup versatile and multipurpose.
                                    The office unit comes with multiple storage options that also serves as a living room showcase. It’s an ideal home office design for urban apartments.
                                    </p>
                                    <p className='extra-info-features'>Special Features</p>
                                    <ul className='extra-info-list'>
                                      <li>A home office cum entertainment unit with an adequately broad desk and a keyboard sliding shelf.</li>
                                      <li>The work desk unit is a part of an ensemble that also consists of a TV unit.</li>
                                      <li>The unit has a sliding panel that can be used as a writing board or to keep the open unit on the other side more secure.</li>
                                      <li>This unit also has multiple open and closed shelves to stack the books and work documents</li>
                                      <li>An armless wooden cushion chair completes the work desk setup.</li>
                                    </ul>

                                 {/* Show less button */}
                                 <button
                                  className='show-less btn  mt-3'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                  >
                                   Show Less ▲  
                                  </button>
                                </div>
                             )}
                            
            </div>

            
            {/* slider-4 end */}
            <div style={{margin:'80px'}}  ></div>
            {/* slider-5 */}
             <div id="carouselExampleIndicators5" class="carousel slide">
                                                <div class="carousel-indicators">
                                                  <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                                  <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                                </div>
                                              <div class="carousel-inner">
                                                  <div class="carousel-item active">
                                                    <img src={industrialstylehomeoffice1} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={industrialstylehomeoffice2} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={industrialstylehomeoffice3} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={industrialstylehomeoffice4} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={industrialstylehomeoffice5} class="d-block w-100" alt="..."/>
                                                  </div>
                                                  <div class="carousel-item">
                                                    <img src={industrialstylehomeoffice6} class="d-block w-100" alt="..."/>
                                                </div>
                                              </div>
                                              <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="prev">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Previous</span>
                                              </button>
                                              <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="next">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Next</span>
                                              </button>
             </div>

             <div className='images-details mt-3'>
                            <p className='img-details-and-btn'>An Industrial Style Home Office Setup For Ideal For Two<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                             {/* Show more button */}
                             {!isExpanded2 && (
                                <button 
                                  className='show-more btn mt-2'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                >
                                 Show More ▼  
                                </button>
                             )}

                             {/* Expanded content */}
                             {isExpanded2 &&(
                                <div className='extra-info mt-3'>
                                    <p className='extra-info-para'>
                                      This refreshingly different home office comes with an industrial design.
                                      The desk is a dark wood finish, one with drawers. The home office, set in an industrial themed space with a concrete finish and exposed brick walls, create a cafe like appeal. 
                                      The office setup is ideal for two people with enough desk space to set up your desktops and laptops.
                                    </p>
                                    <p className='extra-info-features'>Special Features</p>
                                    <ul className='extra-info-list'>
                                     <li>An elongated dark woodwork desk with enough space for two people.</li>
                                     <li>The desk remains attached to a tall wooden bookshelf to stack the books and documents.</li>
                                     <li>There is a wrought iron shelving unit that multiplies the shelf space.</li>
                                     <li>Two metal chairs in blue and red accentuates the industrial appeal of the home office.</li>
                                    </ul>

                                 {/* Show less button */}
                                 <button
                                  className='show-less btn  mt-3'
                                  onClick={toggleContent2}
                                  aria-expanded={isExpanded2}
                                  >
                                   Show Less ▲  
                                  </button>
                                </div>
                             )}
                            
            </div>


            {/* slider-5 end */}
            <div style={{margin:'80px'}}  ></div>
            
        </div>


         {/* *********************************************************** */}
        {/*whychooseourkitchen*/}
                      <div className='whyourkitchen'>
                        <h3>Why Choose Our Home Office Designs</h3>
                         <div className='whyourkitchen-reason'>
                          <div className='icon-para-div1'>
                            <BiSolidOffer className='icon'/>
                            <p className='whyourkitchen-para'>20% Extra Space</p>
                          </div>
                          <div className='icon-para-div1'>
                            <MdOutlineReplay10  className='icon'/>
                            <p className='whyourkitchen-para'>10 Year Warranty</p>
                          </div>
                          <div className='icon-para-div1'>
                            <MdOutlineThumbUpAlt  className='icon'/>
                            <p className='whyourkitchen-para'>Installation by Professionals</p>
                          </div>
                         </div>
                      </div>
        {/*whychooseourkitchen*/}




        
        {/* FAQ's for dining room  design */}
       <div className=' design gallery faq'>
        <h2 className=' design faq-heading'>Frequently asked questions on Home Office Designs</h2>
        {/* <Link to="/contactForm" classNameName="btn btn-warning">Enquiry Form</Link> */}
        <div className="container accordion accordion-flush" id="accordionFlushExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                1.What is the best way to design a home office?
              </button>
            </h2>
            <div id="flush-collapseOne" className="accordion-collapse collapse" >
              <div className="accordion-body">
                <p>Here are some tips for designing your home office:</p>
                  <ul>
                    <li><b>Location:</b>First, find a great location in your home or room because the ambience of your home office will depend on the area of the home it is located in.  Pick a low traffic area to add a soothing appeal to your home office. </li>
                    <li><b>Colour Scheme:</b>Use an inspiring colour scheme for your home office. Use light and neutral colours as those that are too bright can affect your vision during strenuous work hours. </li>
                    <li><b>Invest In Ergonomics: </b>Design your home office with an ergonomic desk and a chair. Have a desk with storage drawers so that you can keep your office space clean and organised. And invest in a good chair for the long work hours.</li>
                    <li><b>Focus On The Desk Space: </b>Just like in a regular office, add some inspiring decoration on the wall in front of your desk. Add a board to pin notes and inspiring quotes to keep you motivated. </li>
                    <li><b>Keep Things Light: </b> Don’t overwhelm yourself with heavy decorations in your home office; keep things airy and light so that you have a clear mind at work. </li>
                    <li><b>Make The Space Comfortable: </b>As you are at home, design your workspace with warm items like pillows in your chair, family photographs, a music system, etc.</li>
                    <li><b>Include Plants:</b> It is essential for you to feel fresh and lively during home office hours — so, you should try adding more and more indoor plants on your desk, near your seat, on the bookshelf, etc.</li>
                    <li><b>Keep Things Handy:</b>Make your home office space-efficient with a well-connected workstation with a good internet connection and a well-maintained desk area.</li>
                  </ul>
         
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                2. How do you lay out a home office?
              </button>
            </h2>
            <div id="flush-collapseTwo" className="accordion-collapse collapse" >
              <div className="accordion-body">
               You can lay out your home office by finding a suitable location in your home and then defining the area with partitions, carpets, etc. 
               The main goal is to create an inspiring and calm place in the house where you can work without encumbrances. Add a suitable desk and an ergonomic chair for your home office to support your body, especially during the long hours.
               You must maintain the storage options in your home office with proper shelving furniture so that you have a clutter-free area. Overall, keep a fuss-free, soothing home office area that will motivate you to work every day.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                3.How do i build a simple home office?
              </button>
            </h2>
            <div id="flush-collapseThree" className="accordion-collapse collapse" >
              <div className="accordion-body">
                Select a suitable, low-traffic area and get a good desk and an ergonomic chair. Then, you can delineate the work area with a semi-closed partition and add a chest of drawers near your office desk.
                You can also add a bookshelf to stack all your documents and work-related books. If you want to define the desk area, you can use a soft floor carpet rug to bring a warm vibe to the place.
                Use simple indoor plants on your desk and other home office areas to keep the site airy and refreshing. Remember to keep things light and minimal with decorations so that you can have a fuss-free workstation.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                4.How can I make my home office look good?
              </button>
            </h2>
            <div id="flush-collapseFour" className="accordion-collapse collapse" >
              <div className="accordion-body">
                <p>You can add certain decor items to make your office look good and inspiring. Some of the DIY tips are as follows:</p>
                    <ul>
                      <li>Use a soothing colour scheme to add a calming vibe to your workplace.</li>
                      <li>Add office essential items such as a pinboard, a chest of drawers for storage and inspiring quotes for everyday motivation.</li>
                      <li>Use wall art such as paintings and family photographs to create a positive work environment.</li>
                      <li>Add indoor plants in the office area so that the workstation feels refreshing at all times.</li>
                      <li>Break the monotony with accent elements like an accent wall, an accent colour book rack, etc.</li>
                      <li>Bring proper lighting to your desk area with some good-looking ceiling lights, desk LED lights, etc. </li>
                      <li>Throw in some pillows and comfortable cushions in your office chair. </li>
                      <li>Locate your home office against a beautiful view so that you can look outside and take time out from the screen.</li>
                    </ul>         
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                5. How do I organise my home office?
              </button>
            </h2>
            <div id="flush-collapseFive" className="accordion-collapse collapse" >
              <div className="accordion-body">
              <p>There are multiple ways to organise your home office. Here are a few tips and tricks to make your home office look chic and cosy:</p>
              <ul>
                <li>Use textured wallpaper on the accent wall to amp up the style quotient of the space.</li>
                <li>Add a table lamp or a floor lamp to illuminate your home office.</li>
                <li>Place some small indoor plants on the desk for freshness.</li>
                <li>A chest of drawers or wall-mounted cabinets to organise your books and official documents in a clutter-free manner.</li>
                <li>A comfortable chair with cushion padding is an absolute must for you to sit and work for longer hours.</li>
              </ul>

              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                6. How do I decorate my home office walls?
              </button>
            </h2>
            <div id="flush-collapseSix" className="accordion-collapse collapse" >
              <div className="accordion-body">
                <p>Make your workstation look lively and welcoming with these home office wall design ideas</p>
                <ul>
                  <li>Choose a tropical or floral-patterned wallpaper for the accent wall.</li>
                  <li>Hang in some wall quotes to keep yourself motivated and focused.</li>
                  <li>Add some hanging or wall-mounted shelves to showcase your books and beautiful showpieces.</li>
                  <li>Some creative wall art and a sleek pendant light add character to the wall.</li>
                  <li>Add a pin board to put up quick notes and to-do lists.</li>
                  <li>A wall clock can help you better manage time and elevate the look of your home office wall.</li>
                </ul>
      
                 
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSeven" aria-expanded="false" aria-controls="flush-collapseSeven">
                7.How do you decorate a modern home office?
              </button>
            </h2>
            <div id="flush-collapseSeven" className="accordion-collapse collapse" >
              <div className="accordion-body">
                <ul>
                  <li>With working from home being the new normal, having a modern home office has become an integral part of most home interiors. Here are some simple ideas for a modern home office:</li>
                  <li>Opt for a lively and vibrant design to make working from home a happy affair.</li>
                  <li>Play with lively colours, tropical wallpapers, turf grass flooring and indoor plants.</li>
                  <li>You can choose a work desk with a wooden top and a metal chest of drawers for a rustic look.</li>
                  <li>Stone-cladding walls with some pendant lights bring in a modern industrial look to your home office.</li>
                  <li>A designer bookshelf will help display your books and other knickknacks.</li>
                </ul>
      
                 
              </div>
            </div>
          </div>
        
        </div>
       </div>


  <p className='disclaimer container'>Kindly note: Product images are representative and may not reflect exact offerings. Please contact us to create a design customized for you.</p>




    </div>
  )
}

export default HomeOffice